<template>
  <v-data-table
    v-bind="$attrs"
    :items="data.results"
    :options.sync="options"
    :loading="loading"
    :headers="computedHeaders"
    disable-sort
    :server-items-length="data.count"
    :footer-props="{
      'items-per-page-options': [
        defaultItemsPerPage,
        2 * defaultItemsPerPage,
        3 * defaultItemsPerPage,
      ],
      'show-current-page': true,
    }"
    @page-count="pageCount = $event"
    v-on="$listeners"
  >
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" #[name]="props">
      <slot :name="name" v-bind="props"></slot>
    </template>
    <template #top>
      <slot name="top" />
      <template v-if="topPagination">
        <v-pagination
          v-model="options.page"
          class="my-1"
          color="primary"
          :length="pageCount"
          total-visible="11"
        />
        <v-divider />
      </template>
    </template>
    <template #footer>
      <v-divider />
      <v-pagination
        v-model="options.page"
        class="my-1"
        color="primary"
        :length="pageCount"
        total-visible="11"
      />
    </template>
    <template #footer.page-text="{ pageStart, pageStop, itemsLength }">
      {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
      <span class="ml-8"> page </span>
      <v-text-field
        v-model.number="options.page"
        dense
        type="number"
        :max="pageCount"
        :min="1"
        hide-details
        class="d-inline-flex centered-input"
        style="max-width: 80px"
      />
    </template>
  </v-data-table>
</template>
<script lang="ts">
import { paginatorMixin } from "@/mixins/paginatorMixin";

export default paginatorMixin().extend();
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
